import { Dashboard } from 'views/dashboard/dashboard';
import { Help } from 'views/dashboard/help';
import { PaymentPending } from 'views/account/paymentPending';
// import { SecurityTraining } from '../views/Training/SecurityTraining/SecurityTraining';


const Routes = [
	{
		path: '/dashboard',
		view: Dashboard,
		layout: 'app',
		permission: 'dashboard.view',
		title: 'dashboard.title',
	},
	{
		path: '/help',
		view: Help,
		layout: 'app',
		permission: 'help.view',
		title: 'help.title'
	},
	{
		path: '/actionrequired',
		view: PaymentPending,
		layout: 'app',
		permission: 'actionrequired.view',
		title: 'Components.PaymentPending.title'
	}
];

export default Routes;
